/**
 * Der Scroll-Knopf (Haus / Pfeil) schreibt nur, was sich ändert. (Chat-Elemente-Plan, Schritt C)
 *
 * `updateScrollBtnVisibility` (app.ts) läuft bei JEDEM Scroll-Ereignis. Jede Schreibung an einem Attribut ist
 * ein Stil-Ungültigmachen — auch mit gleichem Wert. Beim Wischen blieb der Zustand aber fast immer gleich.
 * Hier steht die Prüfung an einem Ort; gibt zurück, wie viele Schreibungen nötig waren (für den Test).
 */
export interface KnopfZustand {
  rolle: "heim" | "runter";
  label: string;
  titel: string;
}

export function schreibeScrollKnopf(btn: HTMLElement, z: KnopfZustand): number {
  let n = 0;
  if (btn.dataset.rolle !== z.rolle) {
    btn.dataset.rolle = z.rolle;
    n++;
  }
  if (btn.hidden) {
    btn.hidden = false;
    n++;
  }
  if (btn.getAttribute("aria-label") !== z.label) {
    btn.setAttribute("aria-label", z.label);
    n++;
  }
  if (btn.title !== z.titel) {
    btn.title = z.titel;
    n++;
  }
  return n;
}
